// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/assets/stock6redTriangleRevised.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App.css */

.App {
  text-align: center;
  z-index: 1;
  /* background-color: aqua; */
}

/* .App {
  
  background: url('../public/assets/stock6redtriangle.png') no-repeat center top;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  background-position-y: 100px;
  min-width: 100vh !important;
  margin: 0 !important;
  padding-top: 0 !important;
  max-height: 800px !important;
} */
.App {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  /* Hide horizontal overflow */
}

.App:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center top;
  background-size: cover;
  /* Cover the entire viewport */
  z-index: -1;
  margin-top: 100px;
}

.amplify-button {
  color: black;
}




.content-link {
  /*margin: 1em;*/
  display: flex;
  justify-content: center;
  gap: 25px;
  /* font-family: Georgia, 'Times New Roman', Times, serif; */
  font-family: 'Avenir Bold', sans-serif;
  font-size: 20px;
  font-weight: 600;
  color: rgb(41, 41, 41);
  /* Adjust the color as needed */
  text-decoration: none;
  transition: color 1.3s ease, transform 1.3s ease, font-size 1.3s ease;
  /* Add a smooth color transition */
  transform-origin: center bottom;
  /* Set the transform origin */
  overflow: hidden !important;
  background-color: #c1c1c1;
  padding-top: 20px;
  margin-bottom: 0px;
  padding-left: 15px;
  padding-right: 15px;
}

@media (min-width: 769px) {
  .content-mobile {
    display: none;
    /* Hide desktop menu on smaller screens */
  }
}

@media (max-width: 768px) {
  .content-desktop {
    /* Hide desktop menu on smaller screens */
    display: none;
  }

  .content-link {
    display: none;
  }
}

.content-desktop {
  /*margin: 1em;*/
  display: flex;
  justify-content: center;
  gap: 5px;
  /* Adjust the color as needed */
  text-decoration: none;
  transition: color 1.3s ease, transform 1.3s ease, font-size 1.3s ease;
  /* Add a smooth color transition */
  transform-origin: center bottom;
  /* Set the transform origin */
  overflow: hidden !important;
  background-color: #c1c1c1;
  padding-top: 20px;
  margin-bottom: 0px;
  padding-left: 30px;
  padding-right: 30px;
  min-height: 80px;
}

.active {
  color: #3b3b3b;
  font-size: 22px;
  background-color: white;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 2px;
  margin-bottom: 45px;
  border-radius: 5px;
}

.desktop-menu {
  display: flex;
  gap: 25px;
}

.desktop-menu a {
  /* Copy the styles from the .content class for desktop menu items */
  font-family: 'Avenir Bold', sans-serif;
  font-size: 20px;

  color: white;
  text-decoration: none;
  transition: color 1.3s ease, transform 1.3s ease, font-size 1.3s ease;
  transform-origin: center bottom;
  overflow: hidden !important;
  background-color: #c1c1c1;
  padding-top: 20px;
  margin-bottom: 0px;
  padding-left: 15px;
  padding-right: 15px;
}

.mobile-menu {
  display: none;
}

@media (max-width: 768px) {
  .content-desktop {
    display: none;
  }

  .content-link {
    display: none;
  }

  .desktop-menu {
    display: none;
  }

  /* .mobile-menu {
    display: flex;
    flex-direction: column;
    gap: 10px;
    position: absolute;
    top: 70px;
    right: 0;
    background-color: #a65252;
    padding: 10px;
    z-index: 1000;
    min-height: 300px;
    min-width: 300px;
  } */

  .mobile-menu.visible .content-link {

    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    gap: 10px;

    top: 10px;
    right: 0px;
    background-color: #c1c1c1;
    padding: 0px;
    z-index: 1000;
    min-height: 10px;
    min-width: 10px;



    /* Change from 'none' to 'flex' */
  }

  .active {
    margin-bottom: 0;
    /* Adjust as needed */
  }

  .content {
    height: 50px !important;
  }
}


/* Additional styles for hamburger menu */
.hamburger {
  display: block;
  background: none;
  border: none;
  font-size: 35px;
  color: white;
  cursor: pointer;
}

.mobile-menu.visible {
  display: flex;
  flex-direction: column;
  width: 100vw;
  gap: 25px;
  position: absolute;
  top: 160px;
  /* Adjust the top position as needed */
  right: 0;
  background-color: #c1c1c1;
  padding: 10px;
  z-index: 1000;
  /* min-height: 300px;
  min-width: 300px; */
}

.content-mobile {
  background-color: #c1c1c1;
  min-height: 60px;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,YAAY;;AAEZ;EACE,kBAAkB;EAClB,UAAU;EACV,4BAA4B;AAC9B;;AAEA;;;;;;;;;;;GAWG;AACH;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,wEAAqF;EACrF,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;;;;AAKA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,2DAA2D;EAC3D,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,qBAAqB;EACrB,qEAAqE;EACrE,kCAAkC;EAClC,+BAA+B;EAC/B,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;IACb,yCAAyC;EAC3C;AACF;;AAEA;EACE;IACE,yCAAyC;IACzC,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,+BAA+B;EAC/B,qBAAqB;EACrB,qEAAqE;EACrE,kCAAkC;EAClC,+BAA+B;EAC/B,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mEAAmE;EACnE,sCAAsC;EACtC,eAAe;;EAEf,YAAY;EACZ,qBAAqB;EACrB,qEAAqE;EACrE,+BAA+B;EAC/B,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;;;;;;;;;;;;KAYG;;EAEH;;IAEE,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,SAAS;;IAET,SAAS;IACT,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,eAAe;;;;IAIf,iCAAiC;EACnC;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;EACzB;AACF;;;AAGA,yCAAyC;AACzC;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,sCAAsC;EACtC,QAAQ;EACR,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb;qBACmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB","sourcesContent":["/* App.css */\n\n.App {\n  text-align: center;\n  z-index: 1;\n  /* background-color: aqua; */\n}\n\n/* .App {\n  \n  background: url('../public/assets/stock6redtriangle.png') no-repeat center top;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-position-y: 100px;\n  min-width: 100vh !important;\n  margin: 0 !important;\n  padding-top: 0 !important;\n  max-height: 800px !important;\n} */\n.App {\n  position: relative;\n  width: 100vw;\n  height: 100vh;\n  overflow-x: hidden;\n  /* Hide horizontal overflow */\n}\n\n.App:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: url('../public/assets/stock6redTriangleRevised.jpg') no-repeat center top;\n  background-size: cover;\n  /* Cover the entire viewport */\n  z-index: -1;\n  margin-top: 100px;\n}\n\n.amplify-button {\n  color: black;\n}\n\n\n\n\n.content-link {\n  /*margin: 1em;*/\n  display: flex;\n  justify-content: center;\n  gap: 25px;\n  /* font-family: Georgia, 'Times New Roman', Times, serif; */\n  font-family: 'Avenir Bold', sans-serif;\n  font-size: 20px;\n  font-weight: 600;\n  color: rgb(41, 41, 41);\n  /* Adjust the color as needed */\n  text-decoration: none;\n  transition: color 1.3s ease, transform 1.3s ease, font-size 1.3s ease;\n  /* Add a smooth color transition */\n  transform-origin: center bottom;\n  /* Set the transform origin */\n  overflow: hidden !important;\n  background-color: #c1c1c1;\n  padding-top: 20px;\n  margin-bottom: 0px;\n  padding-left: 15px;\n  padding-right: 15px;\n}\n\n@media (min-width: 769px) {\n  .content-mobile {\n    display: none;\n    /* Hide desktop menu on smaller screens */\n  }\n}\n\n@media (max-width: 768px) {\n  .content-desktop {\n    /* Hide desktop menu on smaller screens */\n    display: none;\n  }\n\n  .content-link {\n    display: none;\n  }\n}\n\n.content-desktop {\n  /*margin: 1em;*/\n  display: flex;\n  justify-content: center;\n  gap: 5px;\n  /* Adjust the color as needed */\n  text-decoration: none;\n  transition: color 1.3s ease, transform 1.3s ease, font-size 1.3s ease;\n  /* Add a smooth color transition */\n  transform-origin: center bottom;\n  /* Set the transform origin */\n  overflow: hidden !important;\n  background-color: #c1c1c1;\n  padding-top: 20px;\n  margin-bottom: 0px;\n  padding-left: 30px;\n  padding-right: 30px;\n  min-height: 80px;\n}\n\n.active {\n  color: #3b3b3b;\n  font-size: 22px;\n  background-color: white;\n  padding-left: 15px;\n  padding-right: 15px;\n  padding-top: 2px;\n  margin-bottom: 45px;\n  border-radius: 5px;\n}\n\n.desktop-menu {\n  display: flex;\n  gap: 25px;\n}\n\n.desktop-menu a {\n  /* Copy the styles from the .content class for desktop menu items */\n  font-family: 'Avenir Bold', sans-serif;\n  font-size: 20px;\n\n  color: white;\n  text-decoration: none;\n  transition: color 1.3s ease, transform 1.3s ease, font-size 1.3s ease;\n  transform-origin: center bottom;\n  overflow: hidden !important;\n  background-color: #c1c1c1;\n  padding-top: 20px;\n  margin-bottom: 0px;\n  padding-left: 15px;\n  padding-right: 15px;\n}\n\n.mobile-menu {\n  display: none;\n}\n\n@media (max-width: 768px) {\n  .content-desktop {\n    display: none;\n  }\n\n  .content-link {\n    display: none;\n  }\n\n  .desktop-menu {\n    display: none;\n  }\n\n  /* .mobile-menu {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    position: absolute;\n    top: 70px;\n    right: 0;\n    background-color: #a65252;\n    padding: 10px;\n    z-index: 1000;\n    min-height: 300px;\n    min-width: 300px;\n  } */\n\n  .mobile-menu.visible .content-link {\n\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly;\n    gap: 10px;\n\n    top: 10px;\n    right: 0px;\n    background-color: #c1c1c1;\n    padding: 0px;\n    z-index: 1000;\n    min-height: 10px;\n    min-width: 10px;\n\n\n\n    /* Change from 'none' to 'flex' */\n  }\n\n  .active {\n    margin-bottom: 0;\n    /* Adjust as needed */\n  }\n\n  .content {\n    height: 50px !important;\n  }\n}\n\n\n/* Additional styles for hamburger menu */\n.hamburger {\n  display: block;\n  background: none;\n  border: none;\n  font-size: 35px;\n  color: white;\n  cursor: pointer;\n}\n\n.mobile-menu.visible {\n  display: flex;\n  flex-direction: column;\n  width: 100vw;\n  gap: 25px;\n  position: absolute;\n  top: 160px;\n  /* Adjust the top position as needed */\n  right: 0;\n  background-color: #c1c1c1;\n  padding: 10px;\n  z-index: 1000;\n  /* min-height: 300px;\n  min-width: 300px; */\n}\n\n.content-mobile {\n  background-color: #c1c1c1;\n  min-height: 60px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
